import { call, put, takeLatest } from 'redux-saga/effects';
import Module from '../../modules/followup_questions/new';
import 'babel-polyfill';
import axios from '../axios';

function* registerAnswers(action) {
  try {
    const result = yield call(
      function (answers, eventId) {
        const body = JSON.stringify({
          answers: answers,
          event_id: eventId,
        });
        return axios
          .post('/api/questions/event_followup', body)
          .then((response) => response.status === 200)
          .catch(() => false);
      },
      action.payload.answers,
      action.payload.eventId
    );
    if (result) {
      yield put(
        Module.actions.submitSuccess({
          submitStatus: 'success',
          modalIsOpen: true,
        })
      );
    } else {
      yield put(
        Module.actions.submitError({
          submitStatus: 'error',
          modalIsOpen: true,
        })
      );
    }
  } catch (e) {
    yield put(
      Module.actions.submitError({
        submitStatus: 'error',
        modalIsOpen: true,
      })
    );
  }
}

export default function* () {
  yield takeLatest(Module.actions.registerAnswers, registerAnswers);
}
